// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3zbd1","Logo":"Toolbar_Logo__QPR0_","DesktopOnly":"Toolbar_DesktopOnly__16hH4"};